
/**
 * Property-related utility functions
 */

import { Property } from '@/types/property';

export const formatGuestInfo = (guests: number, bedrooms: number, bathrooms: number): string => {
  return `${guests} huéspedes · ${bedrooms} habitaciones · ${bathrooms} baños`;
};

export const formatPropertyCapacity = (guests: number): string => {
  return `${guests} ${guests === 1 ? 'huésped' : 'huéspedes'}`;
};

export const formatRoomInfo = (bedrooms: number, bathrooms: number): string => {
  return `${bedrooms} ${bedrooms === 1 ? 'habitación' : 'habitaciones'} · ${bathrooms} ${bathrooms === 1 ? 'baño' : 'baños'}`;
};

export const checkPropertyAvailability = (property: Property): boolean => {
  return property.available;
};

export const getPropertyDisplayPrice = (price: number): string => {
  return `$${price.toLocaleString()} MXN`;
};

export const validatePropertyCapacity = (property: Property, requiredGuests: number): boolean => {
  return property.guests >= requiredGuests;
};

export const getPropertyShortName = (title: string): string => {
  if (title.includes("Bonito departamento en Manzanillo en planta baja")) return "PDS-Depto-11A";
  if (title.includes("Vista al mar")) return "PDS-Depto-5A";
  if (title.includes("Rooftop")) return "PDS-Roof-7E";
  if (title.includes("Cómodo departamento en Manzanillo con alberca")) return "PDS-Depto-7E";
  return "Unknown";
};
